import Http from "@/Http/Request";
import { RegisterPayload, RegisterResponse } from "./types";
import { useMutation } from "react-query";

const register = async (payload: RegisterPayload) => {
	
	const { data } = await Http({
		method: 'POST',
		url: 'registerUserApi',
		data: payload
	});
	return data;
};


const useRegister = () => {

	const mutation = useMutation<RegisterResponse, Error, RegisterPayload>({
		mutationKey: ['register'],
		mutationFn: (payload: RegisterPayload) => register({
			account: payload.account,
			password: payload.password,
			nickname: payload.nickname,
			remark: payload.remark,
			roleIds: payload.roleIds
		})

	})


  return mutation

}

export default useRegister